<template>
  <img
    :alt="$t.loading"
    class="fixed-0 z-overlay m-a rounded-2xl bg-white bg-op-80"
    height="137"
    src="https://assets.vans.eu/image/upload/v1768557593/vans.gif"
    width="240"
  >
</template>
